import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './LeaderboardsPage.scss'

const LeaderboardsPage = () => {
	return (
		<div className="main-content leaderboards-page">
			<GamificationBlock
				domId={WIDGETS.leaderboards.domId}
				url={WIDGETS.leaderboards.url}
				fit="fill"
				className="gamification-block--page"
			/>
		</div>
	)
}

export default LeaderboardsPage
